"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const user = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        getMe: async () => {
            const endpoint = `${url}/${defaultVersion}/me`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        upgrade: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/upgrade`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        upgradeFromCoursesToKombi: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/upgradeAccountSubscriptionToKombi`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        canCreateSubscription: async (email) => {
            const endpoint = `${url}/${defaultVersion}/users/can-create-subscription`;
            const result = await httpClient.get(endpoint, { auth: false, query: { email } });
            return result.data;
        },
        hasValidLibraryDomain: async (email, library) => {
            const endpoint = `${url}/${defaultVersion}/users/library/validDomain`;
            const result = await httpClient.get(endpoint, { auth: false, query: { email, library } });
            return result.data;
        },
        getLibraryIpRange: async (library) => {
            const endpoint = `${url}/${defaultVersion}/users/library/ipRange`;
            const result = await httpClient.get(endpoint, { auth: false, query: { library } });
            return result.data;
        },
        confirmChangeEmail: async (token) => {
            const endpoint = `${url}/${defaultVersion}/users/changeEmail/confirm`;
            await httpClient.put(endpoint, { payload: { token } });
        },
        changeEmail: async (oldEmail, newEmail, password, isLibraryEmail) => {
            const endpoint = `${url}/${defaultVersion}/users/changeEmail`;
            const payload = {
                oldEmail,
                newEmail,
                password,
                isLibraryEmail,
            };
            await httpClient.put(endpoint, { payload });
        },
        existsByQuery: async (query) => {
            const endpoint = `${url}/${defaultVersion}/users/exists`;
            const result = await httpClient.get(endpoint, { auth: false, query });
            return result.data;
        },
        getUserByToken: async (query) => {
            const endpoint = `${url}/${defaultVersion}/users/exists/token`;
            const result = await httpClient.get(endpoint, { query });
            return result.data;
        },
        getCollections: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/collections`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPinnedDocuments: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/pinnedDocuments`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPinnedContents: async (userId, pagination) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/pinnedDocuments/contents`;
            const result = await httpClient.get(endpoint, { query: pagination });
            return result;
        },
        getRecentlyViewed: async (userId, pagination) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/recentlyViewed/contents`;
            const result = await httpClient.get(endpoint, { query: pagination });
            return result;
        },
        getSubscriptionUpgradePreview: async (userId, licence) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/licence/${licence}/getKombiSubscriptionUpgradePreview`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getDownloadContents: async (userId, pagination) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/downloadList/contents`;
            const result = await httpClient.get(endpoint, { query: pagination });
            return result;
        },
        getDownloadList: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/downloadList`;
            const result = await httpClient.get(endpoint);
            return result;
        },
        update: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        updateNewsletter: async (userId, payload) => {
            const endpoint = `${url}/v3/users/${userId}/newsletter`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        recordTriggeredHint: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/triggered-hints`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        initPasswordReset: async (email) => {
            const endpoint = `${url}/${defaultVersion}/users/passwordReset`;
            await httpClient.post(endpoint, { payload: { email } });
        },
        resetPassword: async (password, passwordRepeat, token) => {
            const endpoint = `${url}/${defaultVersion}/users/resetPassword`;
            const result = await httpClient.put(endpoint, { payload: { password, passwordRepeat, token } });
            return result.data;
        },
        changePassword: async (password, newPassword, newPasswordRepeat) => {
            const endpoint = `${url}/${defaultVersion}/users/changePassword`;
            const result = await httpClient.put(endpoint, {
                payload: { password, newPassword, newPasswordRepeat },
            });
            return result.data;
        },
        getExperimentData: async (userId, experiment) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/experiments`;
            const result = await httpClient.get(endpoint, { query: { name: experiment } });
            return result.data;
        },
        trackExperiment: async (userId, experiment) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/experiments`;
            const result = await httpClient.put(endpoint, { payload: experiment });
            return result.data;
        },
    };
};
exports.default = user;
